import { usePersona } from "@/contexts/PersonaContext";
import { EVENT_CATEGORIES } from "@/data/categories";
import type { EventCategory } from "@/types";

/**
 * Returns the event categories for the current persona.
 * Falls back to default B2B categories if no persona is selected.
 */
export function useCategories(): EventCategory[] {
  const { persona } = usePersona();
  if (persona && persona.categories.length > 0) {
    return persona.categories;
  }
  return EVENT_CATEGORIES;
}
